import { z } from 'zod'

export const RefreshRejectionReasonSchema = z.enum(['idle', 'absolute', 'revoked', 'expired'])
export type RefreshRejectionReason = z.infer<typeof RefreshRejectionReasonSchema>

export const RefreshErrorSchema = z.object({
  message: z.string().optional(),
  extensions: z
    .object({
      reason: RefreshRejectionReasonSchema,
    })
    .optional(),
})

export const RefreshSuccessSchema = z
  .object({
    access_token: z.string().min(1),
    access_token_expiry: z.string().min(1),
    refresh_token: z.string().min(1),
    refresh_token_expiry: z.string().min(1),
    session_started_at: z.string().min(1),
  })
  .superRefine((data, ctx) => {
    const sessionStartedAt = Date.parse(data.session_started_at)
    const accessExpiry = Date.parse(data.access_token_expiry)
    const refreshExpiry = Date.parse(data.refresh_token_expiry)
    if (
      Number.isNaN(sessionStartedAt) ||
      Number.isNaN(accessExpiry) ||
      Number.isNaN(refreshExpiry)
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'One of the timestamps could not be parsed as ISO-8601',
      })
      return
    }
    if (!(sessionStartedAt <= accessExpiry && accessExpiry <= refreshExpiry)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Invariant violated: session_started_at <= access_token_expiry <= refresh_token_expiry',
      })
    }
  })

export type RefreshSuccess = z.infer<typeof RefreshSuccessSchema>

export function parseReason(value: unknown): RefreshRejectionReason {
  const parsed = RefreshRejectionReasonSchema.safeParse(value)
  return parsed.success ? parsed.data : 'expired'
}
